import { SIDEBAR_PANEL_COLLAPSED_STORAGE_KEY } from '@/lib/appConstants.js';

const getInitialWorkspaceSidebarCollapsed = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return true;
  }

  try {
    const storedValue = window.localStorage.getItem(SIDEBAR_PANEL_COLLAPSED_STORAGE_KEY);

    if (storedValue === null) {
      return true;
    }

    const normalizedValue = String(storedValue).trim().toLowerCase();
    return normalizedValue === '1' || normalizedValue === 'true';
  } catch {
    return true;
  }
};

export default getInitialWorkspaceSidebarCollapsed;
